"use client";
import { useState, useRef, useEffect } from "react";

import { Paragraph, Title } from "@/components/ui/typography";
import Link from "next/link";
import useProducts from "@/app/hooks/useProducts";
import { useRouter } from "next/navigation";
import { ChevronDown, ChevronRight } from "lucide-react";
import bannerPromo from "@/public/bannerPromotion.png";
import Image from "next/image";
import Animate from "@/components/Animate";
import { useDispatch } from "react-redux";
import { setSelectedProductId } from "@/app/redux/product-management/product-management-slice";
const CategoriesOne = [
  {
    group: "Must Have",
    items: [
      { name: "Popular Products", link: "" },
      { name: "New Arrivals", link: "" },
      { name: "Special Offers", link: "" },
    ],
  },
  {
    group: "iPads",
    items: [
      { name: "iPad Pro", link: "" },
      { name: "iPad Mini", link: "" },
      { name: "iPad Air", link: "" },
      { name: "iPad", link: "" },
      { name: "Apple Pencil", link: "" },
    ],
  },
  {
    group: "Laptops",
    items: [
      { name: "Apple Macbook", link: "" },
      { name: "Samsung", link: "" },
      { name: "Xiaomi", link: "" },
      { name: "HP", link: "" },
      { name: "Asus", link: "" },
    ],
  },
  {
    group: "Smartphones",
    items: [
      { name: "Apple iPhone", link: "" },
      { name: "Samsung Galaxy", link: "" },
      { name: "Xiaomi", link: "" },
      { name: "Google Pixel", link: "" },
    ],
  },
  {
    group: "Must Have",
    items: [
      { name: "Popular Products", link: "" },
      { name: "New Arrivals", link: "" },
      { name: "Special Offers", link: "" },
    ],
  },
  {
    group: "iPads",
    items: [
      { name: "iPad Pro", link: "" },
      { name: "iPad Mini", link: "" },
      { name: "iPad Air", link: "" },
      { name: "iPad", link: "" },
      { name: "Apple Pencil", link: "" },
    ],
  },
  {
    group: "Laptops",
    items: [
      { name: "Apple Macbook", link: "" },
      { name: "Samsung", link: "" },
      { name: "Xiaomi", link: "" },
      { name: "HP", link: "" },
      { name: "Asus", link: "" },
    ],
  },
  {
    group: "Smartphones",
    items: [
      { name: "Apple iPhone", link: "" },
      { name: "Samsung Galaxy", link: "" },
      { name: "Xiaomi", link: "" },
      { name: "Google Pixel", link: "" },
    ],
  },
  {
    group: "Smartphones",
    items: [
      { name: "Apple iPhone", link: "" },
      { name: "Samsung Galaxy", link: "" },
      { name: "Xiaomi", link: "" },
      { name: "Google Pixel", link: "" },
    ],
  },
  {
    group: "Must Have",
    items: [
      { name: "Popular Products", link: "" },
      { name: "New Arrivals", link: "" },
      { name: "Special Offers", link: "" },
    ],
  },
  {
    group: "iPads",
    items: [
      { name: "iPad Pro", link: "" },
      { name: "iPad Mini", link: "" },
      { name: "iPad Air", link: "" },
      { name: "iPad", link: "" },
      { name: "Apple Pencil", link: "" },
    ],
  },
  {
    group: "Laptops",
    items: [
      { name: "Apple Macbook", link: "" },
      { name: "Samsung", link: "" },
      { name: "Xiaomi", link: "" },
      { name: "HP", link: "" },
      { name: "Asus", link: "" },
    ],
  },
  {
    group: "Smartphones",
    items: [
      { name: "Apple iPhone", link: "" },
      { name: "Samsung Galaxy", link: "" },
      { name: "Xiaomi", link: "" },
      { name: "Google Pixel", link: "" },
    ],
  },
];

export default function AllCategoriesMenu() {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [showSpecialDiv, setShowSpecialDiv] = useState(true);
  const { categoryList } = useProducts();
  const dropdownRef = useRef(null);
  const displayCategories = showSpecialDiv
    ? CategoriesOne.slice(0, -3)
    : CategoriesOne;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mouseout", handleClickOutside);
    return () => {
      document.removeEventListener("mouseout", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [open]);

  const handleCatClick = (cat) => {
    const queryParams = encodeURIComponent(cat);
    window.location.href = `/products?Category=${queryParams}`;
  };

  return (
    <div
      className="relative"
      ref={dropdownRef}
      onMouseOver={() => setOpen(true)}
    >
      <Paragraph className="cursor-pointer wireless-Medium flex items-center">
        All Categories{" "}
        <ChevronDown
          className={`transition-transform duration-300 w-[20px] h-[20px] ${
            open ? "rotate-180 " : ""
          }`}
        />
      </Paragraph>

      <div
        className={`top-[156px]   overflow-hidden  transition-max-height  duration-500 left-[0px] right-0 min-w-[300px] w-full   fixed bg-white z-[999]   shadow    ${
          open ? "max-h-[550px]  p-6" : "max-h-0 p-0"
        } `}
      >
        {open && (
          <Animate delay={0.5}>
            <div className="relative max-w-[1400px] mx-auto px-6 overflow-hidden">
              <div className="grid gap-8 grid-cols-7 ">
                {categoryList
                  ?.filter((item) => item.category_name !== "No Category")
                  ?.map((item, index) =>
                    item?.products?.length > 0 ? (
                      <div
                        key={item.group + index.toString()}
                        className={`flex flex-col col-span-1 cursor-pointer`}
                        onClick={() => handleCatClick(item?.category_name)}
                      >
                        <Animate delay={1 + index * 0.2}>
                          <Title
                            size="xs"
                            className="mb-3 font-[550] leading-[130%]"
                          >
                            {item?.category_name}
                          </Title>
                          <ul>
                            {item?.products &&
                              Array.isArray(item?.products) &&
                              [...item.products]
                                .slice(0, 5)
                                .map((val, index) => {
                                  return (
                                    <li
                                      key={index}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        window.location.href = `/product/${encodeURIComponent(
                                          val?.product_name
                                        )}`; // Navigate to the product page
                                        dispatch(setSelectedProductId(val?.id));
                                      }}
                                      className="text-[16px] font-light   "
                                    >
                                      <Animate delay={0.5 + index * 0.2}>
                                        {" "}
                                        <div className="hoverunderline inline-block">
                                          <span
                                            title={val?.product_name}
                                            className="line-clamp-1"
                                          >
                                            {" "}
                                            {val?.product_name}
                                          </span>
                                        </div>
                                      </Animate>
                                    </li>
                                  );
                                })}
                          </ul>
                        </Animate>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                {showSpecialDiv && (
                  <div className="relative bg-system-azure col-span-3  col-start-5 row-start-1 w-[659px] h-[197px] overflow-hidden p-[20px] flex ">
                    <div className="flex flex-col gap-2 w-[276px]">
                      <Title size="sm" className="mb-2 leading-[120%]">
                        {`Don't Miss Out on Amazing Deals`}
                      </Title>

                      <Paragraph className="text-midnightIndigo-300 leading-[150%]">
                        Join our newsletter and be the first to know about new
                        deals
                      </Paragraph>
                      <div className="">
                        <Link
                          href="/"
                          className=" text-system-primary  items-center gap-1 hoverunderline hoverunderline-blue inline-flex text-[16px] wireless-Medium leading-[150%]"
                        >
                          Subscribe
                          <ChevronRight className="w-[20px] h-[20px]" />
                        </Link>
                      </div>
                    </div>

                    <div className="absolute  left-[293px]  top-[20px] ">
                      <Image
                        src={bannerPromo}
                        alt="banner"
                        height={200}
                        width={368}
                        className="w-[368px] h-[200px] object-cover mix-blend-darken"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Animate>
        )}
      </div>
    </div>
  );
}
